class TiledLevel {

  rows: number;
  columns: number;
  tiles: number[];

  constructor (options: {
    rows?: number,
    columns?: number,
    tiles?: number[]
  } = {}) {
    this.rows = options.rows || 4;
    this.columns = options.columns || 4;
    if (options.tiles) {
      if (options.tiles.length !== (this.rows * this.columns)) throw new Error('Incorrect tiles array length');
      this.tiles = [...options.tiles];
    } else {
      this.tiles = new Array(this.rows * this.columns);
      this.tiles.fill(0);
    }
  }

  at(column: number, row: number): any {
    // TODO: check if is outside indexes
    return this.tiles[row * this.columns + column];
  }

  assign(column: number, row:number, value: number) {
    // TODO: check if is outside indexes
    this.tiles[row * this.columns + column] = value;
  }

}

export default TiledLevel;
